{
  "branding": {
    "frontdesk-attribution": "由 FrontDesk+ 提供支持",
    "practice-logo": "{{name}} 标志"
  },
  "validation": {
    "required": "此字段为必填项",
    "invalid-url": "请输入有效的URL",
    "pin-too-short": "PIN码至少需要4个字符",
    "pin-default-rejected": "不允许使用标准 PIN 0000。请分配您自己的 PIN。",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "返回",
    "next": "下一步",
    "cancel": "取消",
    "confirm": "确认",
    "done": "完成",
    "retry": "重试",
    "clear": "清除",
    "close": "关闭",
    "verifying": "验证中...",
    "select": "选择",
    "minutes": "分钟",
    "clock": "",
    "gender": {
      "M": "男",
      "W": "女",
      "D": "多样",
      "U": "未知"
    },
    "insurance": {
      "GKV": "法定",
      "PKV": "私人",
      "SELFPAY": "自费"
    },
    "scroll-up": "向上滚动",
    "scroll-down": "向下滚动"
  },
  "settings": {
    "device-reset": {
      "title": "重置设备",
      "description": "删除此设备的诊所连接、设备设置和PIN码。",
      "confirmation": "此设备需要重新设置。SOL配置和inSuite中的患者数据不会改变。",
      "cancel": "取消",
      "confirm": "立即重置"
    },
    "title": "设置",
    "save": "保存",
    "save-success": "设置已保存",
    "save-error": "保存设置失败",
    "load-error": "加载设置失败",
    "pin": {
      "title": "需要PIN码",
      "description": "请输入您的PIN码以访问设置。",
      "error": "PIN码错误。请重试。",
      "backspace": "删除最后一位数字"
    },
    "connection": {
      "title": "连接",
      "description": "Doc-Cirrus Bridge服务器的连接设置",
      "bridge-url": "Bridge URL",
      "device-name": "设备名称",
      "device-name-placeholder": "例如接待处，1 号房间，信息亭",
      "device-name-hint": "Bridge 仪表板中用于识别的名称",
      "kim-address": "KIM 地址（可选）",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "测试",
      "success": "连接成功",
      "error": "连接失败",
      "api-unreachable": "DocCirrus API 无法访问",
      "status-title": "连接状态",
      "status": {
        "api": "API 连接",
        "ti": "远程信息处理基础设施",
        "card-reader": "可用读卡器",
        "medical-card": "诊所卡 (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Sol 令牌（来自 inSuite）",
      "sol-token-hint": "请从 inSuite 的 Bridge 管理中复制。连接时需要。",
      "sol-token-show": "显示令牌",
      "sol-token-hide": "隐藏令牌",
      "bridge-unreachable": "无法连接 Bridge。请检查地址和端口。",
      "diagnostic-id": "诊断 ID：{{id}}",
      "scan-qr": "扫描二维码",
      "scan-title": "扫描 Bridge 二维码",
      "scan-manual": "手动输入"
    },
    "terminal": {
      "title": "读卡器",
      "description": "为远程医疗基础设施选择读卡器",
      "select": "选择终端",
      "select-placeholder": "选择终端...",
      "loading": "加载终端中...",
      "none-available": "没有可用的终端",
      "none-found": "未找到终端",
      "found": "找到{{count}}个终端",
      "connect-hint": "请先连接到bridge服务器以加载终端。",
      "found-count": "找到的读卡器：{{count}}",
      "refresh": "重新加载读卡器"
    },
    "practice": {
      "title": "诊所",
      "description": "关于您的诊所的信息",
      "name": "诊所名称",
      "name-placeholder": "例如：王医生",
      "welcome-message": "欢迎消息",
      "welcome-placeholder": "例如：欢迎来到我们的诊所",
      "scheduler-available": "启用调度程序",
      "scheduler-available-description": "允许患者通过自助服务终端进行预约",
      "prescription-available": "启用处方服务",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "留空则以患者的语言显示欢迎语。自定义文本在所有语言中均原样显示。"
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "已为所有设备保存于 {{value}}",
      "never-saved-default": "默认设置，尚未更改。"
    },
    "anamnesis": {
      "title": "数字病史",
      "description": "入住后显示您的病史提供者的链接和 QR code。",
      "enabled": "入住后显示病史链接",
      "enabled-description": "完成登记后显示指向您的病史提供者的链接和 QR code，例如 Nelly。",
      "url": "病史提供者链接",
      "url-hint": "该链接是静态的，并且对于所有患者来说都是相同的。",
      "preview-label": "完成屏幕预览",
      "preview-note": "该链接是静态的，并且对于所有患者来说都是相同的。",
      "url-first": "请先输入有效链接，然后再开启。"
    },
    "appearance": {
      "title": "外观",
      "description": "自定义用户界面",
      "language": "语言",
      "default-kiosk-language": "默认患者语言",
      "default-kiosk-language-hint": "新自助终端会话为患者启动时使用的语言。",
      "voice-over-volume": "画外音音量",
      "voice-over-hint": "控制画外音助手的音量以方便使用。",
      "language-first": "会话开始时显示语言选择"
    },
    "security": {
      "title": "安全",
      "description": "访问设置的PIN码",
      "pin": "PIN码",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "自助终端管理",
    "nav": {
      "general": "常规",
      "flows": "功能",
      "anamnese": "数字病史问卷",
      "device": "设备与连接"
    },
    "flows": {
      "title": "终端上的功能"
    },
    "language": {
      "title": "语言与语音",
      "description": "此设备上面向患者的语言和朗读设置。"
    }
  },
  "self-service": {
    "title": "自助服务",
    "step-progress": "步骤 {{current}} / {{total}}",
    "flows": {
      "checkin": "签到",
      "scheduler": "预约",
      "prescription": "处方",
      "locations": "位置地图",
      "emergency": "急诊"
    },
    "audio-guide": {
      "on": "声音开启",
      "off": "声音关闭",
      "replay": "重播语音指引",
      "replay-unavailable": "暂无可重播的语音指引"
    },
    "language-selector": {
      "title": "选择语言",
      "description": "请选择您的首选语言"
    },
    "settings": "设置",
    "start": {
      "welcome": "欢迎",
      "subtitle": "请选择一个选项",
      "check-in-label": "主路",
      "check-in-cta": "签到",
      "check-in-description": "已有预约？在此签到。",
      "check-in-hint": "准备好你的卡",
      "scheduler-label": "新",
      "scheduler-cta": "预约",
      "scheduler-description": "预约新的就诊时间。",
      "location-plan": "位置地图",
      "location-plan-description": "找到通往治疗室的路。",
      "prescription-label": "处方",
      "prescription-cta": "处方和订购",
      "prescription-description": "查看处方或订单补充。",
      "emergency-cta": "本机紧急警报",
      "emergency-description": "只在此设备上发声，不会呼叫救援。",
      "tap-to-start": "点击开始"
    },
    "offline": {
      "banner-title": "暂时无法办理登机手续",
      "banner-message": "请向接待人员寻求帮助。",
      "emergency-available": "本机警报仍可使用，但不会呼叫救援。",
      "flow-disabled": "暂时不可用"
    },
    "readability": {
      "toggle-label": "阅读模式",
      "on": "阅读模式",
      "off": "阅读模式"
    },
    "reset-overlay": {
      "timeout-title": "会议结束",
      "timeout-subtitle": "你的时间已过。您的数据是安全的。",
      "offline-title": "连接丢失",
      "offline-subtitle": "连接已中断。请与接待人员联系。",
      "interruption-title": "会议结束",
      "interruption-subtitle": "您的会话已安全结束。",
      "completion-title": "谢谢！",
      "completion-subtitle": "您的请求已成功完成。",
      "reassurance": "您的个人数据不会存储在此设备上。",
      "auto-dismiss": "{{seconds}} 秒后返回开始...",
      "dismiss": "开始"
    },
    "timed-terminal": {
      "countdown": "{{seconds}} 秒内自动返回",
      "countdown-outcome": "该终端将自动返回到开始屏幕。",
      "more-time": "更多时间",
      "extended": "时间延长"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "这些问题暂不支持您的语言。请选择提供的语言，或联系前台。",
        "alternatives": "其他可选预约",
        "loading": "正在加载问题…",
        "reception-fallback": "请前往前台。",
        "error-title": "无法加载问题",
        "language-unavailable-lead": "这些问题没有您的语言版本。",
        "language-unavailable-title": "请选择以下语言之一",
        "language-unavailable-body": "或请前台帮助您。"
      },
      "start": {
        "title": "预约",
        "subtitle": "通过几个步骤预约您的首选时间",
        "welcome": "欢迎使用预约系统",
        "description": "我们将引导您完成预约流程",
        "cta": "立即预约"
      },
      "patient-id": {
        "title": "身份识别",
        "subtitle": "请识别您的身份",
        "mode-card": "使用卡片",
        "mode-search": "搜索",
        "mode-create": "创建新的",
        "insert-card": "请插入您的健康保险卡",
        "reading-card": "读卡中...",
        "simulate-card": "模拟卡片",
        "multiple-matches": "找到多个患者。使用卡片数据。",
        "search-placeholder": "姓名或保险号码...",
        "searching": "搜索中...",
        "no-results": "未找到结果",
        "first-name": "名",
        "last-name": "姓",
        "dob": "出生日期",
        "insurance": "保险",
        "continue": "继续",
        "creating": "创建病人...",
        "patient-created": "患者创建成功！",
        "create-error": "无法创建患者。"
      },
      "appointment-type": {
        "title": "选择预约类型",
        "subtitle": "请选择您的就诊原因",
        "loading": "加载预约类型中...",
        "no-types": "没有可用的预约类型",
        "error": "无法加载预约类型。请重试。",
        "no-bookable": "这些预约类型目前无法在自助机上预约。请联系前台或通过电话预约。",
        "disabled-default": "请直接在前台或通过电话预约此项目。",
        "disabled-footer": "仅前台/电话",
        "lead": "您想预约哪种类型的就诊？",
        "duration": "约 {{minutes}} 分钟",
        "empty-title": "目前无法在此预约",
        "none-bookable-title": "这些预约无法在此办理",
        "none-bookable-body": "请询问前台或致电我们。"
      },
      "types": {
        "general": "一般咨询",
        "general-desc": "用于一般投诉和问题",
        "checkup": "预防性检查",
        "checkup-desc": "定期健康检查",
        "vaccination": "疫苗接种",
        "vaccination-desc": "预约疫苗接种",
        "followup": "随访",
        "followup-desc": "随访预约",
        "prescription": "处方",
        "prescription-desc": "取处方"
      },
      "slot-selection": {
        "title": "选择预约",
        "subtitle": "请选择可用的预约",
        "loading": "加载可用预约中...",
        "no-slots": "没有可用的预约",
        "no-appointment-type": "未选择预约类型",
        "error": "无法加载可用时段。请重试。",
        "quick-select": "下一个可用预约：",
        "select-date": "或选择日期：",
        "times-for": "{{date}}",
        "available": "可用",
        "unavailable": "无预约",
        "slots": "时段",
        "select-time-hint": "触摸时间以预约",
        "week-short": "周",
        "weekday-mon": "周一",
        "weekday-tue": "周二",
        "weekday-wed": "周三",
        "weekday-thu": "周四",
        "weekday-fri": "周五",
        "weekday-sat": "周六",
        "weekday-sun": "周日",
        "period-morning": "上午",
        "period-midday": "中午",
        "period-afternoon": "下午",
        "period-evening": "晚上",
        "period-morning-short": "上午",
        "period-midday-short": "中午",
        "period-afternoon-short": "下午",
        "period-evening-short": "晚上",
        "period-dots-legend": "时间可用性",
        "filter-hint": "按首选时间筛选：",
        "or-choose-below": "或选择以下",
        "no-slots-period": "无插槽",
        "show-all": "显示全部",
        "free": "免费",
        "your-selection": "您的选择",
        "oclock": "点",
        "choose-slot": "选择插槽",
        "choose-day": "选择日期",
        "choose-day-first": "请先选择日期",
        "times-heading": "{{date}} 的空闲时间",
        "time-value": "{{time}}",
        "empty-title": "{{month}} 没有空闲预约",
        "empty-body": "请查看下个月或询问前台，我们很乐意帮助您。",
        "next-month": "下个月",
        "previous-month": "上个月"
      },
      "confirmation": {
        "patient-responses": "您的回答",
        "review-loading": "正在核查摘要…",
        "review-unavailable": "摘要不可用。请重试或询问前台。",
        "check-booking": "查看预约状态",
        "title": "确认预约",
        "subtitle": "请查看您的预订",
        "patient": "患者",
        "datetime": "日期和时间",
        "booking": "预约中...",
        "confirm": "预约",
        "heading": "这看起来正确吗？",
        "lead": "请确认您的预约。",
        "appointment": "预约",
        "insured-via": "通过投保",
        "description-label": "给诊所的备注（可选）",
        "description-hint": "如果在预约或签到时有需要注意的事项，请告诉我们。",
        "description-placeholder": "例如行动不便、陪同人员、重要备注",
        "description-too-long": "请将备注控制在 500 个字符以内。",
        "summary": "总结",
        "change": "改变",
        "book-binding": "预约",
        "cancel": "取消",
        "type-label": "预约类型",
        "datetime-value": "{{date}} {{time}}",
        "name-label": "姓名",
        "insurance-label": "保险",
        "insurance-GKV": "法定医疗保险",
        "insurance-PKV": "私人医疗保险",
        "insurance-SELFPAY": "自费",
        "change-time": "更改预约",
        "description-free-text": "其他说明（可选）",
        "note-wheelchair": "我使用轮椅",
        "note-companion": "我有陪同人员",
        "note-interpreter": "我需要翻译"
      },
      "done": {
        "title": "预约成功！",
        "label": "已预订",
        "subtitle": "您的预约已成功预订。",
        "date": "日期",
        "time": "时间",
        "booking-id": "预约号码",
        "qr-hint": "添加到日历",
        "qr-description": "用智能手机相机扫描此二维码以将预约添加到日历应用",
        "auto-redirect": "即将重定向到起始页...",
        "auto-redirect-countdown": "{{seconds}}秒后返回起始页...",
        "back-to-start": "返回起始页",
        "print-button": "打印预约单",
        "print-preparing": "正在准备打印视图…",
        "print-error": "无法打开预约单。请重试或向接待处寻求帮助。",
        "print-returned": "系统打印视图已关闭。如有需要，您可以再申请一份。",
        "print-title": "您的预约",
        "print-location": "地点",
        "print-map-hint": "在手机上打开地点",
        "print-error-v2": "无法打开预约单。请重试或询问前台。"
      },
      "error": {
        "assistance-info": "无法确认您的预约。您的预约可能已经成功。请询问前台。",
        "pending-title": "预约未确认",
        "pending-info": "无法确认您的预约。您的预约可能已经成功。请再次查询或询问前台。",
        "title": "预约失败",
        "subtitle": "无法预约。",
        "info": "请重试或询问前台。"
      },
      "phase": {
        "identify": "登记",
        "choose": "选择时间",
        "confirm": "确认"
      }
    },
    "prescription": {
      "start": {
        "title": "处方和订购",
        "subtitle": "插入您的保险卡即可查看处方或订购续药。",
        "button": "插入卡"
      },
      "card-check": {
        "loading": "正在加载读卡器...",
        "no-terminal": "未配置读卡器",
        "no-terminal-hint": "请联系工作人员寻求帮助。",
        "insert-card": "请插入您的卡",
        "insert-card-hint": "将您的保险卡插入读卡器。",
        "card-detected": "检测到卡",
        "reading": "读卡...",
        "reading-hint": "请稍等。",
        "error": "读卡错误",
        "retry": "再试一次",
        "manual-lookup": "无卡继续",
        "load-error": "无法加载读卡器",
        "read-error": "该卡无法读取"
      },
      "patient-selection": {
        "title": "选择患者",
        "subtitle": "发现多名患者。请选择您的姓名。",
        "try-again": "再试一次",
        "try-again-hint": "再次插入卡"
      },
      "list": {
        "title": "您的处方",
        "for-patient": "{{name}} 的处方",
        "loading": "正在加载处方...",
        "error-title": "加载错误",
        "fetch-error": "处方无法加载",
        "back-home": "返回开始",
        "done": "完成"
      },
      "detail": {
        "prescription-info": "处方信息",
        "date": "日期",
        "prescriber": "处方者",
        "comment": "注意",
        "medications": "药物",
        "form": "表格",
        "pack-size": "包装尺寸",
        "manufacturer": "制造商",
        "loading": "正在加载处方...",
        "fetch-error": "无法加载处方详细信息",
        "back-to-list": "返回列表",
        "print": "打印"
      },
      "types": {
        "public": "公共处方",
        "private": "私人处方",
        "long-term": "长期处方",
        "btm": "麻醉处方",
        "g": "绿色处方",
        "t": "T-处方"
      },
      "no-patient": {
        "title": "未找到患者",
        "subtitle": "不幸的是，没有找到该卡的患者。请联系工作人员寻求帮助。",
        "try-again": "再试一次",
        "back-home": "返回开始",
        "title-v2": "未找到匹配的信息",
        "subtitle-v2": "未能找到您。请重试或询问前台。"
      },
      "done": {
        "title": "谢谢",
        "subtitle": "你现在可以入座了。如有疑问，请联系工作人员。",
        "no-prescriptions-title": "无处方记录",
        "no-prescriptions-subtitle": "我们找不到任何适合您的有效处方。如果您需要，请联系接待人员。",
        "error-title": "发生错误",
        "error-subtitle": "请联系工作人员以获得进一步帮助。",
        "auto-redirect": "{{seconds}} 秒内自动重定向",
        "finish": "返回开始"
      },
      "hub": {
        "title": "您的处方",
        "for-patient": "{{name}} 处方",
        "loading": "正在加载处方...",
        "error-title": "加载错误",
        "fetch-error": "无法加载处方",
        "back-home": "返回开始\n第",
        "done": "完成",
        "order-button": "订单处方",
        "existing-prescriptions": "您当前的处方",
        "no-prescriptions": "未找到有效处方。"
      },
      "patient-lookup": {
        "title": "寻找病人",
        "subtitle": "输入您的姓名和出生日期。",
        "last-name": "姓氏",
        "first-name": "名字",
        "date-of-birth": "出生日期",
        "lastname": "姓氏",
        "lastname-placeholder": "你的姓氏",
        "firstname": "名字",
        "firstname-placeholder": "你的名字",
        "dob": "出生日期",
        "search": "搜索",
        "searching": "正在搜索...",
        "search-error": "搜索错误：{{message}}",
        "no-match": "未找到患者。请检查您的信息。",
        "error": "搜索错误。请再试一次。",
        "found": "找到病人",
        "confirm": "确认",
        "ambiguous": "多次匹配",
        "ambiguous-hint-firstname": "另请输入您的名字以缩小搜索范围。",
        "ambiguous-hint-additional": "请检查您的信息或联系工作人员。",
        "not-found": "未找到患者",
        "not-found-hint": "找不到具有这些详细信息的患者。",
        "not-found-action": "再试一次"
      },
      "manual-identification": {
        "unverified": "您的身份尚未通过健康保险卡确认。诊所将在处理前核实您的信息和申请。"
      },
      "medication-selection": {
        "title": "请求处方",
        "subtitle": "诊所会审核您的请求。批准后，eRx 将在您的 e-prescription 应用中准备就绪。",
        "back": "返回",
        "submit": "继续审查",
        "reason-title": "为什么您需要处方？",
        "reason-hint": "帮助诊所评估您的请求。",
        "reason-validation": "请选择一个原因。",
        "reason-schmerzen": "疼痛",
        "reason-entzuendung": "炎症",
        "reason-nachsorge": "手术后 / 程序",
        "reason-allergie": "过敏 / 反应",
        "reason-chronisch": "慢性病",
        "reason-anderes": "其他的东西",
        "medications-title": "哪些药物？",
        "request-hint": "描述您需要什么，或列出您想要更新的先前处方。",
        "request-placeholder": "例如布洛芬 600 毫克，与上次相同",
        "request-validation": "请描述您需要哪种药物。",
        "history-title": "以前的处方",
        "history-hint": "添加条目以预填写您的请求。",
        "history-loading": "正在加载以前的处方...",
        "history-error": "无法加载之前的处方。",
        "history-add": "添加",
        "history-added": "添加",
        "history-date": "最后：{{date}}",
        "history-request-line": "更新：{{medicationName}}",
        "urgency-title": "有多紧急？",
        "urgency-hint": "帮助诊所确定优先级。",
        "urgency-soon": "紧急\n第",
        "urgency-soon-meta": "尽快",
        "urgency-tomorrow": "很快",
        "urgency-tomorrow-meta": "在接下来的几天里",
        "urgency-week": "本周",
        "urgency-week-meta": "没有时间压力",
        "lead": "诊所将审核您的申请。批准后，您可以在电子处方应用中或医保卡上找到电子处方。",
        "history-hint-v2": "点击以前的处方即可添加。",
        "history-retry": "重新加载"
      },
      "request-review": {
        "title": "审查令",
        "subtitle": "请查看您的处方请求。",
        "request-label": "要求的药物",
        "selected-medications": "选定的药物",
        "free-text-medications": "附加药物",
        "freetext-label": "其他",
        "quarterly-warning": "您的保险卡本季度尚未读取。诊所可能会与您联系。",
        "egk-warning": "您的保险卡本季度尚未读取。诊所可能会与您联系。",
        "submit": "提交",
        "submitting": "正在提交...",
        "submit-error": "无法提交请求。请再试一次。",
        "back": "后退",
        "reason-label": "原因",
        "urgency-label": "紧急",
        "completion-email-choice": "诊所处理完我的申请后，我希望收到电子邮件。",
        "completion-email-label": "电子邮件地址",
        "completion-email-placeholder": "name@example.com",
        "completion-email-hint": "仅用于这一次通知。该地址不会保存为基本资料。",
        "completion-email-invalid": "请输入有效的电子邮件地址。",
        "egk-proof-required": "只有在成功读取医保卡后才能提交处方申请。请联系工作人员。",
        "title-v2": "核对申请",
        "completion-email-hint-v2": "该地址仅用于这一条消息。"
      },
      "confirmation": {
        "title": "请求已发送",
        "subtitle": "您的处方请求已成功提交。",
        "success-title": "请求已发送",
        "success-subtitle": "您的处方请求已成功提交。",
        "estimated-time": "您的处方将在大约 {{time}} 内准备好。",
        "info": "您可以使用保险卡或 eRezept 应用程序在药房领取处方。",
        "auto-redirect": "{{seconds}} 秒内自动重定向",
        "back-to-start": "返回开始",
        "handling-label": "Handled by the practice",
        "next-steps": "诊所将审核您的申请。批准后，您可以凭医保卡或电子处方应用在药店取药。"
      },
      "phase": {
        "identify": "登记",
        "request": "申请",
        "review": "核对"
      }
    },
    "check-in": {
      "flow-label": "办理登机手续\n第",
      "has-appointment": {
        "eyebrow": "预约",
        "title": "您有预约吗？",
        "subtitle": "请选择一个选项",
        "yes-label": "是",
        "yes": "是的，我有预约",
        "yes-description": "我想为我的预约签到。",
        "yes-hint": "最快路径\n第",
        "unsure-label": "也许",
        "unsure": "不确定",
        "unsure-description": "我们将为您检查。",
        "unsure-hint": "我们会寻找你\n第",
        "no-label": "否",
        "no": "没有，无预约",
        "no-description": "我没有预约。",
        "no-hint": "步入式"
      },
      "card-check": {
        "eyebrow": "保险卡",
        "title": "读取健康保险卡",
        "subtitle": "请将您的健康保险卡插入读卡器",
        "insert-title": "请将医保卡插入读卡器。",
        "insert-detail": "我们会自动读取您的详细信息 - 您无需执行任何其他操作。",
        "other-ways": "其他方式",
        "no-card-hint": "如果您现在没有携带卡。",
        "pkv-hint": "将 QR code 与您的保险应用程序一起使用。",
        "loading": "加载设置中...",
        "no-terminal": "未配置读卡器。请联系工作人员。",
        "checking": "检查卡片中...",
        "insert-prompt": "请插入卡片...",
        "card-detected": "检测到卡片！准备读取。",
        "read-card": "读卡",
        "simulate-insert": "模拟卡片",
        "reading": "读卡中...",
        "error": "无法读卡。请重试。",
        "read-error": "读取卡片数据失败。请重试。",
        "settings-error": "无法加载设置。请重试。",
        "no-card-prompt": "没有卡片？",
        "no-card-action": "手动搜索",
        "connection-warning": "读卡器连接问题。请稍等...",
        "pkv-prompt": "私人保险？Online Check-in",
        "pkv-instruction": "使用您的私人健康保险应用程序扫描此 QR code，以数字方式传输您的数据。",
        "pkv-continue": "继续手动注册",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "请重试，或不用卡登记。前台乐意为您提供帮助。",
        "title-pkv": "通过应用登记",
        "title-reading": "正在读取您的卡 …",
        "title-unreadable": "无法读取卡片",
        "title-no-terminal": "不用卡登记",
        "no-terminal-body": "读卡器目前不可用。请不用卡登记，或咨询前台。",
        "reading-detail": "请将卡留在读卡器中，只需片刻。",
        "other-ways-title": "其他方式",
        "no-card-title": "不用卡登记",
        "pkv-prompt-title": "私人保险？",
        "pkv-prompt-hint": "通过您的私人医疗保险应用登记",
        "pkv-close": "还是用卡登记",
        "pkv-instruction-app": "请打开您的私人医疗保险应用并扫描此码，您的信息会直接发送给我们。"
      },
      "patient-selection": {
        "title": "选择患者",
        "subtitle": "找到多个患者。请选择您自己。",
        "firstname-label": "你的名字",
        "firstname-placeholder": "输入名字...",
        "confirm-button": "确认",
        "no-match": "未找到匹配的患者。请前往接待处寻求帮助。",
        "still-ambiguous": "仍有多场比赛。请前往接待处寻求帮助。",
        "select-error": "无法识别患者身份。请再试一次。",
        "staff-assist": "前往接待处",
        "title-v2": "简短确认",
        "subtitle-v2": "为安全起见，请输入您的名字。",
        "no-match-v2": "我们没有用这个名字找到您。请检查拼写或咨询前台。",
        "still-ambiguous-v2": "我们还无法明确找到您。请咨询前台。",
        "select-error-v2": "很遗憾，没有成功。请重试。"
      },
      "card-checkin": {
        "title": "确认签到",
        "subtitle": "您的数据已成功读取。",
        "confirm": "确认签到"
      },
      "register-from-card": {
        "title": "新注册",
        "subtitle": "您尚未在我们的系统中。您想注册吗？",
        "card-data": "卡数据",
        "create": "注册",
        "create-error": "注册失败。请重试或向工作人员寻求帮助。",
        "staff-assist": "致电工作人员",
        "no-card-data-title": "无卡数据",
        "no-card-data": "无法从您的卡读取数据。",
        "insurance-verified": "保险已验证：{{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "卡上的信息",
        "subtitle-v2": "请核对您的信息。如有错误，请点击“更改”。",
        "create-v2": "确认信息",
        "create-error-v2": "很遗憾，登记没有成功。请重试或咨询前台。",
        "insurer-missing-v2": "您的卡上缺少医疗保险信息。请咨询前台。",
        "edit": "更改",
        "name": "姓名",
        "insurer": "医疗保险"
      },
      "patient-lookup": {
        "title": "搜索患者",
        "subtitle": "请输入您的姓名或保险号码。",
        "lastname": "姓",
        "lastname-placeholder": "你的姓氏",
        "dob": "出生日期",
        "firstname": "名",
        "firstname-placeholder": "你的名字",
        "search": "搜索",
        "searching": "正在寻找...",
        "search-placeholder": "姓名或保险号码...",
        "results-placeholder": "搜索结果将显示在此处",
        "found": "病人找到了！",
        "confirm-identity": "请确认您就是所示的患者。",
        "confirm-button": "这就是我",
        "ambiguous-firstname": "发现多名患者。请输入您的名字。",
        "ambiguous-additional": "发现多名患者。请联系工作人员。",
        "disambiguation-hint": "这有助于我们清楚地识别您的身份。",
        "not-found": "未找到具有这些详细信息的患者。",
        "error": "搜索错误：{{message}}",
        "staff-assist": "呼叫工作人员",
        "not-found-prompt": "未找到？",
        "register-new": "注册新患者",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "不用卡登记",
        "subtitle-firstname": "请同时输入您的名字。",
        "ambiguous-firstname-v2": "有多人使用这个姓氏。请同时输入您的名字。",
        "search-again": "重新搜索",
        "found-v2": "已找到您",
        "found-confirm": "请点击“是我”确认。",
        "not-found-title": "没有找到您",
        "not-found-check": "请检查拼写和出生日期。前台乐意为您提供帮助。",
        "not-found-reception": "请检查拼写和出生日期，或咨询前台。",
        "ambiguous-additional-v2": "我们无法明确找到您。请咨询前台。",
        "error-v2": "目前搜索没有成功。请重试。"
      },
      "checking-in": {
        "title": "稍等一下 — 我们正在为您办理登记。",
        "subtitle": "我们正在将您添加到治疗队列中并通知团队。",
        "step-insurance": "保险检查\n第",
        "step-appointment": "任命确认",
        "step-waitlist": "添加到等待名单",
        "error": "入住失败。请再试一次。",
        "continue": "仍然继续",
        "title-v2": "请稍候",
        "loading": "正在为您登记 …",
        "subtitle-v2": "正在将您加入候诊名单并通知团队。",
        "error-title": "很遗憾，没有成功",
        "error-v2": "无法完成您的登记。",
        "error-body": "请重试。如果仍然不行，前台会帮助您。"
      },
      "appointment-selection": {
        "title": "选择预约",
        "subtitle": "您今天有几个约会。请选择一项。\n第",
        "checking-in": "正在检查...",
        "time": "{{time}}",
        "error-v2": "此预约的登记没有成功。请重试或咨询前台。"
      },
      "no-appointment": {
        "title": "未找到预约",
        "subtitle": "我们今天找不到您的预约。请定期预约。",
        "book-appointment": "预约",
        "book-appointment-description": "通过常规调度程序预订新的约会。",
        "staff-assist": "呼叫工作人员",
        "staff-assist-description": "我需要帮助。",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "今天没有找到您的预约。",
        "book-v2": "预约新时间",
        "book-v2-description": "请现在选择一个空闲时间。",
        "have-appointment": "我有预约",
        "have-appointment-description": "前台乐意为您提供帮助。",
        "unavailable-title": "请在前台预约",
        "subtitle-unavailable": "今天没有找到您的预约。请咨询前台。"
      },
      "staff-assist": {
        "title": "通知工作人员",
        "subtitle": "工作人员将很快为您提供帮助。",
        "message": "请在此等候。工作人员很快就会与您联系。",
        "start-over": "返回开始",
        "auto-redirect": "{{seconds}} 秒后返回开始...\n第"
      },
      "eeb-prompt": {
        "title": "验证保险",
        "title-failed": "验证失败",
        "subtitle": "您想如何验证您的保险？",
        "subtitle-failed": "用您的保险应用扫描二维码以请求验证。",
        "verify-card": "电子验证",
        "verify-card-description": "向您的保险公司发送请求。",
        "select-insurer": "选择保险公司",
        "select-insurer-description": "手动选择您的保险公司。",
        "skip": "跳过",
        "eyebrow-chip": "替代方案",
        "eyebrow": "办理登机手续·保险证明 (eEB)",
        "recommended": "推荐",
        "qr-title": "使用您的保险应用程序扫描",
        "qr-description": "打开您的健康保险应用程序并扫描代码 - eEB 会直接发送给我们。",
        "qr-address-label": "发送至",
        "title-app": "通过应用提供证明",
        "subtitle-app": "您的医疗保险也可以直接把证明发给我们。完成后请点击“下一步”。"
      },
      "quarterly-check": {
        "title": "保险检查",
        "checking": "正在检查您当前的保险验证...",
        "error": "无法执行检查。",
        "title-v2": "您的保险",
        "checking-v2": "正在核查您的保险 – 请稍候。",
        "error-body": "您的登记已完成。前台会与您一起处理保险事宜。"
      },
      "insurer-prefilled": {
        "title": "您的健康保险",
        "subtitle": "请确认本季度的保险。",
        "your-insurance": "您的保险",
        "last-read": "上次检查于{{date}}",
        "quarterly-notice": "出于计费目的，我们需要本季度的当前保险证明。",
        "confirm-button": "是的，这是我的保险",
        "change-button": "我有不同的保险",
        "contact-title": "请求电子承保证明",
        "contact-description": "致电您的保险公司并索取电子承保证明：",
        "contact-patient": "病人",
        "contact-kim-address": "诊所 KIM 地址",
        "contact-phone": "电话",
        "question": "这是您的医疗保险吗？",
        "quarterly-notice-v2": "每季度我们需要一次您的医疗保险证明。"
      },
      "insurer-search": {
        "title": "选择健康保险",
        "subtitle": "请搜索并选择您的法定健康保险。",
        "placeholder": "搜索保险...",
        "hint": "输入至少2个字符进行搜索。",
        "no-results": "未找到保险。",
        "no-results-hint": "检查拼写或尝试其他搜索。",
        "label": "您的医疗保险名称",
        "search-error-v2": "目前搜索没有成功。请重试。",
        "app-alternative": "想用医疗保险应用吗？"
      },
      "insurer-contact": {
        "title": "索取保险证明",
        "subtitle": "请选择以下选项之一。",
        "or": "或",
        "option-eeb-title": "电子请求",
        "option-eeb-description": "如果存在法定例外情形，在您同意后可将请求转交给诊所团队。",
        "option-qr-title": "使用应用程序扫描",
        "option-qr-description": "使用您的保险应用程序扫描 QR code。\n第",
        "option-call-title": "给自己打电话",
        "option-call-description": "请致电您的保险方，并为此诊所申请 eEB:",
        "phone": "电话",
        "phone-not-available": "保险卡上的电话号码\n第",
        "patient-name": "病人",
        "practice-kim": "诊所 KIM 地址",
        "help-notice": "如果您有任何问题，请前往接待处。",
        "submit-eeb-button": "立即请求\n第",
        "contacted-button": "我已经打电话了",
        "contacted-button-countdown": "通话时间 ({{seconds}}s)",
        "go-to-counter-button": "前往接待处\n第",
        "qr-continue-button": "我已扫描",
        "qr-continue-button-countdown": "扫描时间 ({{seconds}}s)",
        "title-v2": "您的医疗保险证明",
        "subtitle-v2": "最简单的方式是使用医疗保险应用。",
        "subtitle-no-app": "请选择医疗保险向我们发送证明的方式。",
        "option-eeb-description-v2": "我们代您向医疗保险申请。为此需要您的同意。",
        "call-instruction": "请致电您的医疗保险，请他们把证明发送到我们诊所。",
        "call-instruction-practice": "请致电您的医疗保险，请他们把证明发送到 {{practice}} 诊所。",
        "done-button": "已完成 – 下一步",
        "done-button-countdown": "已完成 – 下一步（还剩 {{seconds}} 秒）"
      },
      "eeb-consent": {
        "title": "同意",
        "subtitle": "我们需要您的同意进行电子保险验证。",
        "insurance": "您的保险",
        "consent-title": "电子保险验证同意书（eEB）",
        "consent-text": "我理解，我的健康保险方将通过安全的 KIM 通信服务，把我的保险数据（例如姓名、出生日期、保险号码）传输给诊所 {{practiceName}}，作为保险证明。我同意此次传输。我知道我可以随时撤回此同意，且不会影响我的治疗。",
        "withdrawal-notice": "您可以随时撤回此同意。",
        "agree-button": "我同意",
        "decline-button": "取消",
        "treatment-notice": "您的治疗不受此同意的影响。",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "您的医疗保险证明",
        "summary": "您的医疗保险会直接把证明发给我们。为此需要您的同意。",
        "confirm-first": "请先确认声明。"
      },
      "qr-code": {
        "title": "用保险应用扫描",
        "instruction-1": "打开您的保险应用并扫描此二维码。",
        "instruction-2": "随后，诊所将自动收到您的保险验证。",
        "practice": "诊所: {{name}}",
        "alternative-hint": "替代方案：使用您的保险应用",
        "instruction-app": "请打开您的医疗保险应用并扫描此码，证明会直接发送给我们。",
        "staff-line": "供诊所工作人员使用：{{address}}",
        "staff-line-practice": "供诊所工作人员使用：{{name}} · {{address}}",
        "alternative-app": "您也可以通过医疗保险应用申请证明：打开应用并扫描此码。"
      },
      "register-basics": {
        "title": "个人信息",
        "subtitle": "请输入您的详细信息。",
        "family-name": "姓",
        "given-name": "名",
        "dob": "出生日期",
        "gender": "性别",
        "insurance-type": "保险类型",
        "insurer-name": "您的保险名称",
        "insurer-name-placeholder": "例如德贝卡、DKV、安联……",
        "gender-required": "请选择一项。"
      },
      "register-insurer": {
        "title": "健康保险",
        "subtitle": "请选择您的健康保险。",
        "search-placeholder": "搜索保险..."
      },
      "register-details": {
        "title": "摘要",
        "subtitle": "请查看您的信息。",
        "create": "完成注册",
        "missing-data": "请填写所有必填字段。",
        "create-error": "注册失败。请再试一次。",
        "policy-number": "保单编号（可选）",
        "policy-number-placeholder": "您的保单号码\n第",
        "create-v2": "完成登记",
        "policy-number-hint": "号码在您的保险卡上。"
      },
      "diff-review": {
        "eyebrow-chip": "审查",
        "eyebrow": "办理登机手续·卡数据",
        "title": "数据比较",
        "subtitle": "您的卡片数据与我们的记录之间存在差异。",
        "col-current": "当前记录",
        "col-new": "卡中的新内容\n第",
        "new-badge": "新\n第",
        "field-fallback": "领域",
        "note": "更新的数据有助于我们正确计费并在紧急情况下联系您。",
        "comparison-placeholder": "比较将显示在此处",
        "confirm": "确认更改",
        "apply-error": "数据无法应用。请再试一次。",
        "retry": "重试",
        "skip": "仍然继续",
        "no-changes": "未找到更改",
        "title-v2": "您的信息已更改",
        "subtitle-v2": "您的卡上有更新的信息。要采用吗？",
        "confirm-v2": "采用并登记",
        "keep": "不更改直接登记",
        "col-current-v2": "原有",
        "col-new-v2": "卡上的新信息",
        "value-yes": "是",
        "value-no": "否"
      },
      "insurance-selection": {
        "title": "保险类型",
        "subtitle": "请选择您的保险类型。",
        "gkv": "法定保险",
        "gkv-description": "法定健康保险成员。",
        "pkv": "私人或自费",
        "pkv-description": "私人保险或自费。",
        "pkv-description-v2": "私人医疗保险，或自费。"
      },
      "eeb-request": {
        "title": "请求已记录",
        "subtitle": "您可以完成登记。{{insurer}} 的答复稍后会送达诊所。",
        "verifying": "您的请求已被接受并将立即处理。",
        "success": "您的请求已安全转交给诊所团队。",
        "error": "无法获取请求确认。",
        "try-alternative": "替代方法",
        "kim-load-error": "无法加载诊所 KIM 地址。",
        "kim-label": "诊所 · KIM",
        "non-blocking-note": "这尚不能确认您的医疗保险已收到，也不能确认您的参保状态。",
        "auto-continue": "{{seconds}} 秒后自动继续。",
        "unavailable-title": "很遗憾，没有成功",
        "unavailable-v2": "无法记录您向医疗保险提交的申请。",
        "unavailable-body": "您可以通过医疗保险应用发送证明，或在前台处理。",
        "use-app": "使用应用",
        "at-reception": "在前台处理"
      },
      "self-pay": {
        "title": "自费",
        "subtitle": "您将作为自费患者接受治疗。",
        "info": "请注意，您将负责治疗费用。",
        "confirm": "我明白",
        "title-v2": "自费",
        "subtitle-v2": "治疗费用由您自行支付。",
        "insured-after-all": "我其实有保险"
      },
      "done": {
        "title": "完成！",
        "subtitle": "您的签到已完成。",
        "finish": "完成",
        "done-label": "完毕",
        "error-label": "注意",
        "eyebrow": "入住·完成",
        "queue-label": "候车室",
        "queue-title": "请入座",
        "queue-meta": "我们将亲自给您打电话。",
        "success-title": "签到成功！",
        "success-subtitle": "请在候诊室就座。您将被叫到。",
        "auto-redirect": "即将重定向到起始页...",
        "auto-redirect-countdown": "{{seconds}} 秒后返回开始...",
        "card-expired-title": "卡片已过期",
        "card-expired-subtitle": "您的健康保险卡已过期。",
        "card-expired-info": "请联系工作人员寻求帮助。",
        "back-to-start": "返回起始页",
        "anamnesis-title": "完整的病史表",
        "anamnesis-description": "扫描 QR code 以在智能手机上方便地填写您的病史表。",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "您已登记",
        "card-expired-info-v2": "请咨询前台。"
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "核对您的信息",
          "balance-prefix": "保存时：",
          "balance-direct-v2": "立即保存：{{count}}",
          "balance-reception-v2": "由前台核查：{{count}}",
          "chip-reception-v2": "更改由我们的前台核查",
          "chip-changed": "已更改：{{count}}",
          "remove": "删除",
          "example-email": "例如 name@example.cn",
          "example-phone": "例如 138 1234 5678",
          "intro-v2": "您的登记已完成。这些信息仍然正确吗？核对是自愿的。",
          "auto-hide": "显示的内容会在短时间后再次隐藏。"
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "我们已将此信息转交前台。",
          "banner-done-v2": "谢谢！我们已收到您的信息。",
          "footer-v2": "其他信息保持不变。"
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "出于隐私保护，我们已关闭显示。您的登记仍已完成。您可以随时向前台告知更改。"
        }
      },
      "progress": {
        "identify": "登记",
        "insurance": "保险",
        "done": "完成"
      },
      "dob-format-hint": "例如 01.10.1980",
      "dob-required": "请输入您的出生日期。",
      "insurance-label": {
        "GKV": "法定保险",
        "PKV": "私人保险",
        "SELFPAY": "自费"
      }
    },
    "emergency": {
      "title": "紧急紧急情况！\n第",
      "label": "紧急情况",
      "subtitle": "此警报仅在本地响起，尚未呼叫救援。遇到急性或可能危及生命的紧急情况，请拨打112。",
      "call-emergency": "呼叫紧急服务 (112)\n第",
      "stop-sound": "停止声音",
      "play-sound": "播放声音\n第",
      "back-to-start": "返回开始",
      "headline": "请立即与前台工作人员联系。如有生命危险，请拨打 112。"
    },
    "help-reception": "接待帮助",
    "help-reception-toast": "请联系接待处。我们很乐意提供帮助。",
    "language-entry": {
      "title": "请选择语言"
    },
    "loading": "加载中…",
    "step-progress-label": "进度",
    "step-progress-phase": "第 {{current}} 部分，共 {{total}} 部分：{{phase}}",
    "step-progress-substep": "第 {{current}} 项，共 {{total}} 项",
    "step-progress-complete": "已完成",
    "identification": {
      "title": "请问您是哪位？",
      "lead": "使用医保卡最快捷。您也可以按姓名查找。",
      "lead-card-only": "请将医保卡插入读卡器。",
      "mode-label": "您想如何登记？",
      "mode-card": "使用卡片",
      "mode-search": "按姓名查找",
      "mode-create": "初次就诊",
      "card": {
        "loading": "正在准备读卡器 …",
        "checking": "正在检查读卡器 …",
        "insert-title": "请将医保卡插入读卡器。",
        "insert-detail": "我们会自动读取您的信息。",
        "detected": "已识别卡片",
        "read": "读取卡片",
        "reading": "正在读取卡片 …",
        "reading-hint": "请不要拔出卡片。",
        "no-terminal-title": "读卡器不可用",
        "help-with-search": "请按姓名查找或询问前台。",
        "help-reception": "请询问前台，我们很乐意帮助您。",
        "unreadable-title": "已识别卡片，但无法读取",
        "error-title": "无法读取卡片",
        "not-unique": "无法通过此卡准确识别您。请按姓名查找或询问前台。",
        "no-match": "未找到与此卡匹配的信息。请按姓名查找或询问前台。",
        "without-card": "不用卡继续"
      },
      "lookup": {
        "lead": "请输入您的姓氏和出生日期。",
        "first-name": "名字",
        "last-name": "姓氏",
        "dob": "出生日期",
        "dob-hint": "格式：日.月.年",
        "search": "查找",
        "confirm": "是的，是我",
        "found-title": "已找到您",
        "found-body": "请确认这是您本人。",
        "first-name-needed-title": "请补充您的名字",
        "first-name-needed-body": "以便准确找到您。然后点击“查找”。",
        "ambiguous-title": "无法准确找到您",
        "ambiguous-body": "请询问前台，我们很乐意帮助您。",
        "not-found-title": "未找到匹配的信息",
        "not-found-body": "请检查您输入的信息。",
        "error-title": "目前无法查找",
        "error-body": "请重试或询问前台。"
      },
      "create": {
        "insurance-question": "您的保险类型是？",
        "insurance-required": "请选择您的保险类型。",
        "error-title": "无法保存您的信息",
        "error-body": "请重试或询问前台。"
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "先解锁",
      "subtitle": "FrontDesk+ 必须在练习软件中激活。",
      "step1": "在 SolStore 中订购（或您的 Doc-Cirrus 合作伙伴为您订购）。",
      "step2": "激活后，在inSuite中“inSuite Sols”（管理员权限）下激活。",
      "step3": "打开Bridge管理→“添加设备”。",
      "cta": "一切完成 - 继续"
    },
    "welcome": {
      "title": "将此设备添加到练习中",
      "scan": "拍一下代码的照片",
      "prepare-link": "inSuite中没有代码？",
      "language": "语言"
    },
    "scan": {
      "requesting": "请求访问相机...",
      "scanning": "将相机对准代码",
      "paste": "粘贴代替",
      "manual-title": "手动连接",
      "manual-description": "如果二维码不可用，请从 Bridge 管理处获取连接数据。",
      "address-label": "Bridge地址",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "插入 SOLTOKEN",
      "manual-submit": "接管连接",
      "error-title": "代码无法识别",
      "camera-denied-title": "相机访问被拒绝",
      "camera-denied-hint": "请在设置中允许相机访问，然后重试。",
      "retry": "再试一次"
    },
    "preflight": {
      "title": "将设立",
      "all-green": "所有测试均通过",
      "practice": "实践",
      "device-name": "设备名称",
      "device-name-placeholder": "例如B、接待1",
      "card-reader": "读卡器",
      "pin": "新的秘密号码",
      "pin-placeholder": "四位数 PIN 码",
      "finish": "结束",
      "recheck": "再次检查",
      "diagnosis": "诊断ID",
      "checklist-error": "Bridge 拒绝了连接或无法访问。请检查 SOLTOKEN 和 Bridge 地址。",
      "checklist-retry": "重新检查",
      "edit-token": "更改 SOLTOKEN",
      "rescan": "重新扫描二维码"
    },
    "persisting": "正在保存设置 …",
    "success": {
      "title": "设备已添加",
      "detail": "该设备刚刚出现在练习电脑上。",
      "starting": "病人模式正在启动……"
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "连接练习软件",
        "fix": "Bridge 检查连接和服务器地址。"
      },
      "missing_insuite_url": {
        "label": "inSuite地址",
        "fix": "再次扫描二维码——地址丢失。"
      },
      "missing_server_token": {
        "label": "服务器令牌",
        "fix": "再次扫描二维码 - 令牌丢失。"
      },
      "missing_gateway_session": {
        "label": "Gateway 会话",
        "fix": "再次登录 — 会话丢失。"
      },
      "missing_gateway_enrollment": {
        "label": "设备注册",
        "fix": "在Gateway上注册设备。"
      },
      "gateway_not_ready": {
        "label": "Gateway 准备情况",
        "fix": "等待Gateway完成设置。"
      },
      "token_verification_failed": {
        "label": "令牌检查",
        "fix": "检查服务器令牌或 Bridge 连接。"
      },
      "session_expired": {
        "label": "会议",
        "fix": "会话已过期 - 重新登录。"
      },
      "device_revoked": {
        "label": "设备状态",
        "fix": "该设备已被阻止。联系实践。"
      },
      "missing_practice_name": {
        "label": "诊所名称",
        "fix": "无法加载医疗机构名称 (inSuite)."
      },
      "missing_device_name": {
        "label": "设备名称",
        "fix": "请输入设备名称。"
      },
      "telematik_unavailable": {
        "label": "远程信息处理基础设施",
        "fix": "可选 — 一旦 TI 可用，卡检查仍然可以进行。"
      },
      "selected_card_reader_unavailable": {
        "label": "读卡器",
        "fix": "可选 — 选择或连接读卡器。"
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "可选 — 插入医疗执业凭证卡 (SMC-B)."
      }
    },
    "token": {
      "title": "输入 SOLTOKEN",
      "description": "出于安全原因，二维码中不包含 SOLTOKEN。请在 inSuite 的“Sol-Aktivierung”（FrontDesk+）中复制并粘贴到此处。",
      "submit": "继续",
      "rescan": "重新扫描二维码"
    }
  }
}
